import type { Chat } from '../../types';
import { safeJsonDate, safeJsonDateRequired, transformDates } from './date';

export function transformKolSearchResult(result: Chat.KolSearch<string>): Chat.KolSearch<Date> {
  return {
    ...result,
    citations: result.citations.map<Chat.Citation>(citation => transformDates(citation) as Chat.Citation),
    createdOn: safeJsonDateRequired(result.createdOn),
  };
}